export default "__VITE_ASSET__CSjFaGzu__";